import { KanbanUser, CreateCardRequest } from '../../types/kanban';
import { AvatarColor } from './avatarUtils';

export interface CardColor {
  name: string;
  value: string;
  label: string;
}

export const CARD_COLORS: CardColor[] = [
  { name: 'None', value: '', label: 'No Color' },
  { name: 'Blue', value: '#2196F3', label: 'Blue' },
  { name: 'Green', value: '#4CAF50', label: 'Green' },
  { name: 'Orange', value: '#FF9800', label: 'Orange' },
  { name: 'Purple', value: '#9C27B0', label: 'Purple' },
  { name: 'Red', value: '#F44336', label: 'Red' },
  { name: 'Yellow', value: '#FFEB3B', label: 'Yellow' },
];

export interface CreateTaskDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onCreateCard: () => Promise<void>;
  newCard: Partial<CreateCardRequest>;
  setNewCard: (card: Partial<CreateCardRequest>) => void;
  selectedAssignees: string[];
  setSelectedAssignees: (assignees: string[]) => void;
  validationErrors: Record<string, string>;
  setValidationErrors: (errors: Record<string, string>) => void;
  availableMembers: KanbanUser[];
  userPhotos: Record<string, string>;
  getAvatarColor: (userId: string) => AvatarColor;
  onAssigneeSelectionChange: (selectedOptions: string[]) => void;
  onRemoveAssignee: (userId: string) => void;
  customUserInput: string;
  setCustomUserInput: (value: string) => void;
  onAddCustomUser: () => void;
  themedScrollbarClass: string;
}

export const getPriorityColor = (priority: string): string => {
  switch (priority) {
    case 'high': return 'danger';
    case 'medium': return 'warning';
    case 'low': return 'success';
    default: return 'informative';
  }
};
